if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText =
          this.submitButton.querySelector('.quick-add__submit-text') ||
          this.submitButton.querySelector('span:not(.quick-add__submit-icon):not(.sold-out-message)');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        this.moveUploadContainer();
        this.uploadObserver = new MutationObserver(() => this.moveUploadContainer());
        this.uploadObserver.observe(this, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.uploadObserver?.disconnect();
      }

      moveUploadContainer() {
        if (this.closest('.custom-product-card')) {
          this.removeCardAppFields();
          return;
        }

        const buttons = this.querySelector('.product-form__buttons');
        const slot = this.querySelector('[data-product-form-upload]');
        if (!buttons || !slot) return;

        const upload = buttons.querySelector('.upload-container');
        if (!upload || upload.parentElement === slot) return;

        slot.appendChild(upload);
      }

      removeCardAppFields() {
        const form = this.form;
        if (!form) return;

        form.querySelectorAll('.upload-container, .filepond--root, [class*="filepond"]').forEach((el) => {
          el.remove();
        });

        [...form.children].forEach((child) => {
          if (child.matches('input[type="hidden"][name="id"], button[type="submit"]')) return;
          child.remove();
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);

        const loadingText = this.submitButton.dataset.loadingText || this.dataset.loadingText;
        const labelSpan = this.submitButtonText;
        let originalLabelText;
        if (loadingText && labelSpan) {
          originalLabelText = labelSpan.textContent;
          labelSpan.textContent = loadingText;
        } else {
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner')?.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.resetQuantityInput();
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (loadingText && labelSpan && originalLabelText !== undefined) {
              labelSpan.textContent = originalLabelText;
            } else {
              this.querySelector('.loading__spinner')?.classList.add('hidden');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      resetQuantityInput() {
        const quantityInput = this.form.querySelector('input[name="quantity"]');
        if (!quantityInput) return;

        const minValue = quantityInput.min ? parseInt(quantityInput.min, 10) : 1;
        quantityInput.value = Number.isNaN(minValue) ? 1 : minValue;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
